import { Age, ageObj, Gender, genderObj, PricesType, pricesTypesObj, Style, styleObj } from '../models/models-front';
import Utils from './utils';

export const prefix = 'garderobo';

export const deviceType = Utils.getScreenType();

export const enum LStorage {
    _garderoboSessionKey = '_garderoboSessionKey',
    _garderoboUserParams = '_garderoboUserParams',
    likedProductIds = '_garderoboLikedProductIds',
    similarResult = '_garderoboSimilarResult',
}

export class LStorageController {
    public static getUserParams() {
        const userParams = localStorage.getItem(LStorage._garderoboUserParams);
        return userParams ? JSON.parse(userParams) : {};
    }

    public static setPricesType(pricesType: PricesType) {
        const userParams = this.getUserParams();
        userParams['prices_type'] = pricesType;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getPricesType(): PricesType {
        return this.getUserParams()['prices_type'] || pricesTypesObj[0].code;
    }

    public static setGender(pricesType: Gender) {
        const userParams = this.getUserParams();
        userParams['gender'] = pricesType;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getGender(): Gender {
        return this.getUserParams()['gender'] || genderObj[0].code;
    }

    public static setStyle(style: Style) {
        const userParams = this.getUserParams();
        userParams['style'] = style;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getStyle(): Style {
        return this.getUserParams()['style'] || styleObj[0].code;
    }

    public static setClothSizes(sizes: Array<string>) {
        const userParams = this.getUserParams();
        userParams['cloth_sizes'] = sizes;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getClothSizes(): Array<string> {
        return this.getUserParams()['cloth_sizes'] || [];
    }

    public static setShoesSizes(sizes: Array<string>) {
        const userParams = this.getUserParams();
        userParams['shoes_sizes'] = sizes;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getShoesSizes(): Array<string> {
        return this.getUserParams()['shoes_sizes'] || [];
    }

    public static setAge(age: Age) {
        const userParams = this.getUserParams();
        userParams['age'] = age;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getAge(): Age {
        return this.getUserParams()['age']; // || ageObj[0].code;
    }

    public static setCategoryGroups(categories: Array<string>) {
        const userParams = this.getUserParams();
        userParams['category_groups'] = categories;
        localStorage.setItem(LStorage._garderoboUserParams, JSON.stringify(userParams));
    }

    public static getCategoryGroups(): Array<string> {
        return this.getUserParams()['category_groups'] || [];
    }
}
